import * as React from 'react';

import ReactMarkdown from 'react-markdown';
import { CreateSurveyProps } from '../common/CreateSurveyProps';
import Header from '../components/header';

interface iState {
    markdownText: string
}
export class GithubMarkdown extends React.Component<CreateSurveyProps, iState> {
    
        state = {
            markdownText: 
`## Headings
----
To create heading add one to six \`#\` symbol before heading text \`e.g.\`

# H1
\`# H1\`

### H3
\`### H3\`

~~~


~~~

## Styling text
----
### Bold
For bold add \`**\` before and after the text \`e.g.\`

\`This is **a bold** text\`

This is **a bold** text 

### Italic
For italic add \`*\` before and after the text \`e.g.\`

\`This is *an italic* text\`

This is *a italic* text 

~~~


~~~

## Horizontal line
For horizontal line use three or more Hyphens (\`-\`)  \`e.g.\`

\`----\`

----

~~~


~~~

## Link
----

A link can be created by wrapping display text in brackets [ ], and then wrapping the URL in parentheses ( )
\`e.g.\`

\`[Click here](https://patientombudsman.ca)\`

[Click here](https://patientombudsman.ca)

~~~


~~~

\`[patientombudsman.ca](https://patientombudsman.ca)\`

[patientombudsman.ca](https://patientombudsman.ca)

~~~


~~~

**Note:** that the url has \`https://\` prefix. If you want a phone # as link then use \`tel://\` and if you want an email as link then use \`mailto:\` for \`e.g.\`.

\`[1-888-321-0339](tel://18883210339)\`

[1-888-321-0339](tel://18883210339)

\`[info@patientombudsman.ca](mailto:info@patientombudsman.ca)\`

[info@patientombudsman.ca](mailto:info@patientombudsman.ca)

~~~


~~~

## Bullet list
----
For bullet list add \`-\` or \`+\` before text and for nested bullet add two spaces \`e.g.\`

+ Bullet list item 1
    - Nested bullet
    - Sub-nested bullet 

- Bullet list item 2 

~~~
+ Bullet list item 1
    - Nested bullet
    - Sub-nested bullet 

- Bullet list item 2 

~~~


~~~

`
    }

    render() {
        return (
            <React.Fragment>
                <Header></Header>

                <div className="main-row">
                    <div className="row" >

                        <div className="col-sm-6">
                            <label className="form-label text-success">Markup (try editing text):</label>
                            <textarea className='form-control height-100' value={this.state.markdownText}
                            onChange={(e)=> this.setState({markdownText: e.target.value})}></textarea>
                        </div>
                        <div className="col-sm-6">
                            <label className="form-label text-success">Output:</label>

                            <ReactMarkdown children={this.state.markdownText} />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default GithubMarkdown;
